export const getLanguageCode = (locale: string) => {
  return locale.replace('pl', 'po').replace('cy-gb', 'cy');
};
